import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, Play, Image as ImageIcon } from "lucide-react";
import { filterCss } from "@/lib/filters";
import { api, formatCount } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

export function InstitutionShorts({ institutionId }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    setItems(null);
    api.get("/shorts", { params: { institution_id: institutionId, limit: 20 } }).then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, [institutionId]);

  return (
    <section data-testid="institution-shorts-section">
      <h2 className="mb-3 text-lg font-extrabold">Curtas</h2>
      {items === null ? (
        <div className="grid grid-cols-3 gap-2">{Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="aspect-[9/16] rounded-xl" />)}</div>
      ) : items.length === 0 ? (
        <p className="rounded-2xl bg-white/5 py-10 text-center text-sm text-muted-foreground" data-testid="institution-shorts-empty">Nenhum vídeo curto publicado ainda.</p>
      ) : (
        <div className="grid grid-cols-3 gap-2" data-testid="institution-shorts-grid">
          {items.map((s) => (
            <Link key={s.id} to={`/curtas?v=${s.id}`} className="group relative aspect-[9/16] overflow-hidden rounded-xl bg-card" data-testid={`institution-short-${s.id}`}>
              <img src={s.poster_url} alt={s.caption} loading="lazy" style={{ filter: filterCss(s.edits?.filter) }} className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
              {s.media_type === "photo" ? <ImageIcon size={16} className="absolute right-1.5 top-1.5 text-white/80" /> : <Play size={16} className="absolute right-1.5 top-1.5 text-white/80" fill="currentColor" />}
              <div className="absolute inset-x-1.5 bottom-1.5">
                <p className="line-clamp-2 text-[10px] font-semibold leading-tight">{s.caption}</p>
                <p className="mt-0.5 inline-flex items-center gap-1 text-[10px] font-bold font-mono-k"><Heart size={10} fill="currentColor" className="text-rose-400" /> {formatCount(s.likes)}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
